<style lang="less" scoped>
.box {
  padding: 16px 12px;
  background-color: #fff;
  font-family: number-bold;
  .top_box {
    display: flex;
    .logo {
      width: 88px;
      height: 88px;
      border-radius: 4px;
      margin-right: 8px;
      border: 2px solid #efefef;
    }
    .text {
      height: 88px;
      .title {
        width: 255px;
        height: 44px;
        color: var(--, #252e39);
        font-family: PingFang SC;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
      }
      .shop {
        width: 255px;
        height: 44px;
        display: flex;
        flex-direction: column;
        .shop_top {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .shop_box {
            display: flex;
            flex: 1;
            span {
              color: var(--unnamed, #8e9aae);
              font-family: PingFang SC;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              margin-right: 4px;
            }
            p {
              color: var(--, #252e39);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
            }
          }
        }
        .shop_bottom {
          flex: 1;
          display: flex;
          align-items: center;
          .list {
            padding: 2px 8px;
            background-color: #e9f1ff;
            border-radius: 12px;
            color: #2877ff;
            font-family: PingFang SC;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 12px;
            margin-right: 6px;
          }
        }
      }
    }
  }

  .anchor {
    display: flex;
    align-items: center;
    margin: 12px 0 16px 0;
    justify-content: space-between;
    .anchor_box {
      flex: 1;
      display: flex;
      align-items: center;
      span {
        color: var(--unnamed, #8e9aae);
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
      }
      img {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid #efefef;
        margin-right: 6px;
      }
      .name {
        width: 68px;
        color: #141b27;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .button {
    display: flex;
    margin-bottom: 16px;
    .btn {
      width: 96px;
      height: 30px;
      border-radius: 4px;
      background: #2877ff;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
    }
  }
}
</style>
<template>
  <div class="box">
    <div class="top_box">
      <img :src="info.logo" alt="" class="logo" />
      <div class="text">
        <div class="title">{{ info.name }}</div>
        <div class="shop">
          <div class="shop_top">
            <div class="shop_box">
              <span>星级购物评分</span>
              <p style="color: #ff5000">{{ info.star }}</p>
            </div>
            <div class="shop_box">
              <span>店铺总销量</span>
              <p>{{ info.salesVolume }}</p>
            </div>
          </div>
          <div class="shop_bottom">
            <div class="list" v-for="item in info.category">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anchor">
      <div class="anchor_box" @click="to(info.brandLink)">
        <span>主营品牌：</span>
        <img :src="info.brandImg" alt="" />
        <div class="name">{{ info.brandName }}</div>
      </div>
      <div class="anchor_box"  @click="to(info.anchorLink)">
        <span>绑定达人：</span>
        <img :src="info.anchorImg" alt="" style="border-radius: 10px" />
        <div class="name">{{ info.anchorName }}</div>
      </div>
    </div>
    <div class="button">
      <div class="btn" @click="chooseCollection">
        {{isFavorite ? '已关注' : '关注'}}
      </div>
    </div>
  </div>
</template>

<script>
import ShopIconLabel from "./shopIconLabel";
export default {
  components: { ShopIconLabel },
  props: { data: Object },
  data() {
    return {
      isFavorite:false
    }
  },
  mounted() {
    this.isFavorite = this.data.isFavorite
  },
  methods:{
    chooseCollection() {
      if (this.$store.state.userLevel && this.$store.state.userLevel <= 100) {
        if (this.isFavorite) {
          this.deCollection();
        } else {
          this.putCollection();
        }
      } else {
        this.$store.commit('WRITEOVERLAYSHOW', { status: true,textChange:'monitor' });
      }
    },
    deCollection() {
      this.$dialog.confirm({
        title: '提示',
        message: `您将取消对${this.info.name}的关注`
      }).then(() => {
        this.$toast.clear();
        this.$showLoading();
        this.$del({
          road: 'userFavorites',
          params: { targetId: this.info.id,type: 4},
          version: 'v22'
        }).then(res => {
          this.$toast.clear();
          this.$toast(`取消成功`);
         this.isFavorite = false
        }).catch(err => {
          this.$toast(`取消失败`);
          this.$toast.clear();
        });

      });
    },
    putCollection() {
      this.$dialog.confirm({
        title: '提示',
        message: `您将关注${this.info.name}`
      }).then(() => {
        // 清空弹窗
        this.$toast.clear();
        // 出现loading
        this.$showLoading();
        // 数据发送
        this.$post({
          road: 'userFavorites',
          params: { targetId: this.info.id,type: 4},
          version: 'v22'
        }).then(res => {
          this.$toast.clear();
          this.$toast(`关注成功`);
          this.isFavorite = true
        }).catch(err => {
          this.$toast.clear();
          this.$toast(`关注失败`)
        });
      });
    },
    to(url) {
      this.$router.push({path:url})
    }
  },
  computed: {
    info: (_this = this) => {
      const info = _this.$props.data || {};
      return {
        logo: info.logo ? info.logo : _this.$defaultSrc,
        name: info.name ? info.name : "-",
        id:info.id,
        star: info?.score || "-",
        isFastReplySeller: info?.isFastReplySeller === 1, // 极速回复
        isGoldCSSeller: info?.isGoldCSSeller === 1, // 金牌客服
        isSellingTalentSeller: info?.isSellingTalentSeller === 1, // 卖货达人
        isSellingMasterSeller: info?.isSellingMasterSeller === 1, // 卖货大
        isBrand: info?.isBrand === 1, // 品牌店
        isHighQualityAnchor: info?.isHighQualityAnchor === 1, //优质商家
        anchorImg: info?.anchor?.avatar
          ? info?.anchor?.avatar
          : _this.$defaultSrc, // 达人头像
        anchorName: info?.anchor?.name || "-", //达人名称
        anchorFansCount: info?.anchor?.fans
          ? _this.$retainWan(info?.anchor?.fans)
          : "-", // 粉丝数
        anchorLink: `/anchor/${info?.anchor?.id}`, // 达人链接

        brandImg: info?.brand?.image || _this.$defaultSrc, // 品牌图片
        brandName: info?.brand?.name || "-", //品牌名称,
        brandLink: info?.brand?.id ? `/brand/${info?.brand?.id}` : null,
        salesVolume: info?.salesVolume
          ? _this.$retainWan(info?.salesVolume)
          : "-", //总销量
        category: info?.category || [],
      };
    },
  },
};
</script>
